import React, { useEffect, useRef, useState } from 'react'
import DigitalSignatureComponent from '../../common/DigitalSignatureComponent'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { AcceptedTermsCondition, RemoveStudentSignature, UploadStudentSignature } from '../../../services/QuizService';
import { handleUploadToS3BucketUrl } from '../../common/uploadFileToS3';
import Swal from 'sweetalert2';
import styled from 'styled-components';
import { BodySmall, Heading5, TextLink } from '../../common/GlobalElements/Typography';
import CustomCheckbox from '../../common/GlobalElements/CustomCheckbox';
import { getSignatureQa, mergeSignatureQa } from '../../../utils/signatureQaStorage';

const QuizSignatureContainer = styled.div`
  border-radius: var(--border-radius);
  background: var(--surfaces-container-background);
`;

const DeclarationText = styled(BodySmall)`
  color: var(--text-secondary);
`;

const CheckboxContainer = styled.div`
  margin-top: 30px;
  margin-bottom:10px;
  text-align: left;
`;



function QuizSignature({assignmentData, attempt, link, isAssessmentReview, setIsSignatureChanged, isSignatureChanged}) {
    const signaturePadRef = useRef()
    const [ipAddress, setIpAddress] = useState('');
    const [cDate,setCDate] = useState('')
    const [isSig,setIsSig] = useState(false)
    const {aid} = useParams();
    const [sigType,setSigType] = useState(0);
    const [readOnly,setReadOnly] = useState(false);
    const [readOnlyData,setReadOnlyData] = useState(false);
    const [loading,setLoading] = useState(false);
    const [buttonLoading,setButtonLoading] = useState(false);
    const [initialComp,setInitialComp] = useState(0)
    const [errorWhileUpload,setErrorWhileUpload] = useState(false);

    const updateCheck = (check) => {
        setButtonLoading(true)
        const dateNow = Date.now();
        const data = {
            assessment_id : aid,
            attempted_no : attempt,
            is_terms_checked : check ? 1 : 0
        }
        AcceptedTermsCondition(data)
        .then((success) => {
            setButtonLoading(false)
            mergeSignatureQa(success.data.getStudentSignature);
        })
        .catch((err) => {
            setButtonLoading(false)
            console.log(err)
        }).finally(() => {
            setIsSignatureChanged(dateNow);
        });
    }

    useEffect(() => {
        const saveSignature = async () => {
            const formData = new FormData();
            const dateNow = Date.now();
            formData.append('assessment_id', aid);
            
            formData.append('signature_date', cDate);
            formData.append('signature_ip', ipAddress);
            formData.append('signature_type',sigType);
            formData.append('attempted_no',attempt)

            if(ipAddress != ''){
                setLoading(true)

                const user = localStorage.getItem("user");
                const userData = JSON.parse(user);

                const originalName = isSig.name.split('.')[0];
                const extName = isSig.name.split('.')[1]

                const filePath =`Students/${userData?.id}_${userData?.student_crm_id}_${userData?.first_name}_${userData?.last_name}/${assignmentData?.id}_${assignmentData?.name}/${assignmentData?.name}_${userData?.student_crm_id}_signature_${Date.now()}.${extName}`;
                
                let awsFileUploadedUrl = [];

                awsFileUploadedUrl.push({
                  file_name: filePath,
                  file_type: isSig.type,
                });


                const resultData = await handleUploadToS3BucketUrl(awsFileUploadedUrl, isSig);
                if(!resultData){
                    Swal.fire({
                      icon: "error",
                      title: "signature upload Failed",
                      timer: 2000,
                    }).then(() => {
                        setButtonLoading(false);
                        setIsSignatureChanged(dateNow);
                        setLoading(false);
                        setErrorWhileUpload(true);
                    });      
                    return;
                  }
                resultData.forEach((result) => {
                formData.append('signature_name', result.path);
                });

                UploadStudentSignature(formData)
                .then((response) => {
                    mergeSignatureQa(response.data.getStudentSignature);
                    setReadOnlyData(response.data?.getStudentSignature);
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(false)
                    console.log("QuizSignature -> uploadStudentSignature: Error: " + error);
                }).finally(() => {
                    setIsSignatureChanged(dateNow);
                });
            }
        }
        saveSignature()
    },[isSig,ipAddress])

    useEffect(() => {
        const signatureQa = getSignatureQa();
        if (signatureQa) {
            const localData = JSON.parse(signatureQa);
            if(isAssessmentReview){
                setReadOnly(true)
            }
            else if(!localData?.signature || localData?.signature == "" || localData?.signature == "null"){
                setReadOnly(false)
            }else{
                setReadOnly(true)
            }
            setReadOnlyData(localData)
        }
    }, [getSignatureQa()]);

    const removeSignature = (initialComp) => {
        setReadOnly(false)
        setInitialComp(initialComp)
        const dateNow = Date.now();
        RemoveStudentSignature({id : readOnlyData?.id})
        .then((response) => {
            setLoading(false)
            mergeSignatureQa(response.data.getStudentSignature);
        })
        .catch((error) => {
            setLoading(false)
            console.log("QuizSignature -> removeStudentSignature: Error: " + error);
        }).finally(() => {
            setIsSignatureChanged(dateNow);
        })
    }

    const isChecked = readOnlyData?.is_terms_checked || false;
    return (
      <QuizSignatureContainer>
        <Heading5>Student Declaration</Heading5>

        <DeclarationText>
          I/we declare that all the information included in this assignment is my/our original work,
          apart from where source material has been acknowledged. I/we acknowledge that I/we am/are
          aware of AIE's Plagiarism Policy and understand the consequences of breaching this policy
          – as well as any other AIE policy relevant to me/us.
        </DeclarationText>

        <DigitalSignatureComponent
          errorWhileUpload={errorWhileUpload}
          setErrorWhileUpload={setErrorWhileUpload}
          signaturePadRef={signaturePadRef}
          cDate={cDate}
          setCDate={setCDate}
          ipAddress={ipAddress}
          setIpAddress={setIpAddress}
          setIsSig={setIsSig}
          setSigType={setSigType}
          readOnly={readOnly}
          readOnlyData={readOnlyData}
          from={'quiz'}
          removeSignature={removeSignature}
          loading={loading}
          initialComp={initialComp}
          isAssessmentReview={isAssessmentReview}
        />

            <CheckboxContainer>
                <CustomCheckbox
                    id="customCheck2"
                    name="term_condn"
                    checked={isChecked}
                    onChange={(e) => { updateCheck(e.target.checked) }}
                    disabled={buttonLoading || isAssessmentReview}
                    label={
                        <>
                            I hereby confirm that I have read, understood and accepted
                            all <TextLink href={link} target="_blank">Terms and Conditions</TextLink> as set out in the application form that the above subject selections are correct, and understand
                            that there may be changes made based on the academic outcome.
                        </>
                    }
                    required={true}
                    showError={false}
                    error={!isChecked ? "You must accept the terms and conditions to submit." : ""}
                    touched={true}
                    marginBottom="0"
                />
            </CheckboxContainer>
      </QuizSignatureContainer>
    )
}

export default QuizSignature;